import AppointmensState from '../../../../../../consts/AppointmentsState';
import { parseDate } from '../wallet-section/walletFormat';

/** Atendimento realizado (ou falta) ainda sem fatura: a cobrança de fato. */
export const isOverdue = (item) => item.status === 'completed' || item.status === 'noshow';

/** Situação da cobrança: pago, realizado sem pagamento, ou o estado do agendamento. */
export function paymentState(item) {
  if (item.invoiceId && item.invoiceId !== '0') return { label: 'Pago', tone: 'paid' };
  if (isOverdue(item)) return { label: 'Sem pagamento', tone: 'overdue' };
  const date = parseDate(item.date);
  if (date && date > new Date()) return { label: 'Agendado', tone: 'scheduled' };
  return { label: AppointmensState.GetLabel(item.status), tone: 'muted' };
}
